import memoise from "../../../common/utils/memoise";
import { impactIndex, impactLookup } from "../constants/pathogenicity";

function calcCodingImpact(impact) {
  if (impact) {
    const impacts = String(impact || "")
      .split(",")
      .map((x) => x.toLowerCase().replace(/\s/g, ""))
      .map((x) => impactIndex[x]);

    return impactLookup[Math.min(...impacts)];
  }
  return null;
}

const getCodingImpact = memoise(calcCodingImpact);

export default getCodingImpact;
